import { toast } from "react-toastify";

export const uploadPowerProof = async ({
  file,
  largeBondId,
  powerNumber,
  token,
  baseURL,
}) => {
  if (!file || !largeBondId || !token || !baseURL) {
    console.warn("Missing upload parameters");
    return;
  }

  // Ensure we can iterate even if it's a single file
  const files = Array.isArray(file) || file instanceof FileList ? file : [file];

  for (const f of files) {
    const formData = new FormData();
    formData.append("file", f);

    let url = `${baseURL}largebond/${largeBondId}/upload-power-proof`;
    if (powerNumber) {
      url += `?powerNumber=${encodeURIComponent(powerNumber)}`;
    }

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!res.ok) throw new Error("Upload failed");

      toast.success(`✅ ${f.name} uploaded successfully!`);
    } catch (err) {
      console.error(`❌ Upload failed for ${f.name}:`, err);
      toast.error(`❌ Failed to upload ${f.name}.`);
    }
  }
};
